import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const socialYoutube = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.67 4.097c-.184-.69-.725-1.233-1.413-1.418C13.01 2.334 8 2.334 8 2.334s-5.01 0-6.257.345C1.055 2.864.514 3.407.33 4.097 0 5.347 0 8 0 8s0 2.653.33 3.903c.184.69.725 1.233 1.413 1.418C3.01 13.666 8 13.666 8 13.666s5.01 0 6.257-.345c.688-.185 1.229-.728 1.413-1.418C16 10.653 16 8 16 8s0-2.653-.33-3.903zM6.4 10.4V5.6L10.667 8 6.4 10.4z" fill="#191919"/>
</svg>`
);
